module.exports = __webpack_public_path__ + "assets/traingle-arrow-up.c3857099.svg";